import { render, staticRenderFns } from "./ApHistory.vue?vue&type=template&id=af0efa10"
import script from "./ApHistory.vue?vue&type=script&lang=js"
export * from "./ApHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports